// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachWeekendOfMonth as fn } from "../eachWeekendOfMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachWeekendOfMonthWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default eachWeekendOfMonthWithOptions;
